import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'moment/locale/ja';
import moment from 'moment';
import { Button } from '../util';

import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import './Dashboard.css';

/**
 * @prop diaryRequest
 */
export default class Dashboard extends React.Component {

  constructor (props) {
    super(props);


  }

  componentDidMount () {
    document.getElementById('diary').addEventListener('focus', () => {
      [].forEach.call(document.getElementsByClassName('diary-border'), i =>
        i.style.borderColor = 'cyan');
    });
    document.getElementById('diary').addEventListener('blur', () => {
      [].forEach.call(document.getElementsByClassName('diary-border'), i =>
        i.style.borderColor = '#ffd756');
    });
  }

  saveDiary() {
    let data = JSON.parse(localStorage.diary_posts);
			data[moment().format('YYYY-MM-DD').substr(0, 10)] = document.getElementById('diary').value;
    localStorage.diary_posts = JSON.stringify(data);
  }


  render() {
    if (!localStorage.diary_posts) localStorage.diary_posts = "{}";
    return (
      <div>
        <header className="App-header">
          <div id="logo">
            <div onClick={this.props.openDashboardHandler}>
              <h1 style={{fontSize: '2.3em', position: 'relative', bottom: '.8em', textShadow: 'none'}}>Diary</h1>
            </div>
          </div> 
        </header>
  
        <article>
          <p className="lead">Dashboard</p>

          <section>
            <h3>Today's Diary --- {moment().format('ll')}</h3>
            <hr className="diary-border" id="diary-border-1" />
            <textarea id="diary" defaultValue={JSON.parse(localStorage.diary_posts)[moment().format('YYYY-MM-DD').substr(0, 10)]}>   
            </textarea>
            <hr className="diary-border" id="diary-border-2" />
            <Button value="Save this diary" onClick={this.saveDiary} />
           </section>

          <section>
            <h3>Check previous diaries</h3>
            <DatePicker
              inline
              // selected={moment()}
              onChange={this.props.diaryRequest}
            />
          </section>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page/Dashboard.js